import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { BehaviorSubject, map, catchError, tap } from 'rxjs';
import { Proposition } from '@app/models';
import { DataService } from '@app/services';

import * as _ from 'lodash';

@Injectable()
export class PropositionService {
    constructor(
        private httpClient: HttpClient,
        private dataService: DataService
    ) { }

    getPendingPropositions(userId) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}propositions/read_pending`,
                JSON.stringify({ userId: `${userId}` })
            )
            .pipe(
                tap((res) => {
                    //pub compteurs badges
                    if(res?.document) this.dataService.changeMessage('counts', res.document);
                }),
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    getReceivedPropositionsById(depositor_id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}propositions/read`,
                JSON.stringify({ depositor_id: `${depositor_id}` })
            )
            .pipe(
                map(res => res? res.document.records as Proposition[] : []),
                catchError(this.handleError)
            );
    }

    getSentPropositionsById(sender_id) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}propositions/read`,
                JSON.stringify({ sender_id: `${sender_id}` })
            )
            .pipe(
                map(res => res? res.document.records as Proposition[] : []),
                catchError(this.handleError)
            );
    }

    // Admin : recuperation de toutes les propositions
    getPropositionsToManage() {
        return this.httpClient
        .get<any>(`${environment.apiEndPoint}propositions/read_manage`)
            .pipe(
                map(res => res ? res.document.records as Proposition[] : []),
                catchError(this.handleError)
            );
    }

    // une proposition par son ID
    getPropositionById(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}proposition/read_one`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    // Admin : une proposition par son ID
    getPropositionToManageById(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}proposition/read_manage_one`, object)
            .pipe(
                map(res => res.document),
                catchError(this.handleError)
            );
    }

    createProposition(object: Proposition) {
        return this.httpClient
            .post(`${environment.apiEndPoint}proposition/create`, object)
            .pipe(
                tap((res) => {
                    //refresh
                    if(res) {
                        this.getPendingPropositions(object.sender_id).subscribe();
                    }
                }),
                map(res => res),
                catchError(this.handleError)
            );
    }

    publishProposition(object: any) {
        return this.httpClient
            .post(`${environment.apiEndPoint}proposition/publish`, object)
            .pipe(
                tap((res) => {
                    //refresh
                    if(res) this.getPendingPropositions(object.sender_id).subscribe();   
                }),
                map(res => res as Proposition),
                catchError(this.handleError)
            );
    }

    rejectProposition(object: any) {
        return this.httpClient
            .post(`${environment.apiEndPoint}proposition/reject`, object)
            .pipe(
                tap((res) => {
                    //refresh
                    if(res) this.getPendingPropositions(object.depositor_id).subscribe();
                }),
                map(res => res as Proposition),
                catchError(this.handleError)
            );
    }

    publishManageProposition(object: any) {
        return this.httpClient
            .post(`${environment.apiEndPoint}proposition/publish_manage`, object)
            .pipe(
                map(res => res as Proposition),
                catchError(this.handleError)
            );
    }

    testPublication(object: any) {
        return this.httpClient
            .post<any>(`${environment.apiEndPoint}test/publication`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    createEvaluation(object) {
        return this.httpClient
            .post(`${environment.apiEndPoint}evaluation/create`, object)
            .pipe(
                map(res => res),
                catchError(this.handleError)
            );
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error);
    }
}
